import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { tokenSelector } from '../../store//auth/selectors';

const useAuth = () => {
  const { search } = useLocation();
  const accountReference = new URLSearchParams(search).get('accountReference');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const token = useSelector(tokenSelector);

  useEffect(() => {
    if (accountReference) {
      //save in session storage.
      window.sessionStorage.setItem('accountReference', accountReference);
    } else {
      //check session storage for existing account reference.
      const savedAccountReference = getSavedAccountReference();
      setIsLoggedIn(savedAccountReference !== null);
    }
  }, [accountReference, token]);

  const getSavedAccountReference = () => window.sessionStorage.getItem('accountReference') || null;

  const getDetails = (successCallback, errorCallback) => {};

  return { isLoggedIn, getDetails, accountReference: getSavedAccountReference() };
};

export default useAuth;
